__turbopack_context__.v({
  "affirmContent": "order-review-module-scss-module__iGUKRa__affirmContent",
  "borderCol": "order-review-module-scss-module__iGUKRa__borderCol",
  "col": "order-review-module-scss-module__iGUKRa__col",
  "confirmation": "order-review-module-scss-module__iGUKRa__confirmation",
  "divider": "order-review-module-scss-module__iGUKRa__divider",
  "infoWrapper": "order-review-module-scss-module__iGUKRa__infoWrapper",
  "orderReviewWrapper": "order-review-module-scss-module__iGUKRa__orderReviewWrapper",
  "progressiveReview": "order-review-module-scss-module__iGUKRa__progressiveReview",
});
